export const MAX_COEF = 10.00;
export const MIN_COEF = 1.00;
export const STEP = 0.2;
export const THREE = 3;
